module.exports = __webpack_public_path__ + "static/headshot-michael-lynn-3x.1b15331f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-michael-lynn-3x.jpg
// module id = 526
// module chunks = 152909308826437